export enum KeyboardCalendarEventInteraction {
    Open = 'Open',
    Delete = 'Delete',
    Forward = 'Forward',
    ReplyAll = 'ReplyAll',
    Reply = 'Reply',
}
